module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_gk_qyjk.7a6f3a58.png";